import { useEffect, useRef, useLayoutEffect } from "react";

const useClickAway = (cb: any) => {
  const ref = useRef(null);
  const refCb = useRef(cb);

  useLayoutEffect(() => {
    refCb.current = cb;
  }, [cb]);

  useEffect(() => {
    const handler = (e: any) => {
      const element = ref.current as any;
      if (element && !element.contains(e.target)) {
        refCb.current(e);
      }
    };

    document.addEventListener("mousedown", handler);
    document.addEventListener("touchstart", handler);

    return () => {
      document.removeEventListener("mousedown", handler);
      document.removeEventListener("touchstart", handler);
    };
  }, []);

  return ref;
};

export default useClickAway;
